import React, { Component  } from 'react';
import { Link } from 'react-router-dom';
import logo from './images/sun-loan-logo-2.svg';
import {userService} from '../_services/user.service'
import { history } from "../_helpers/history"
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap"
import { SlButton } from './editors';
import { metadataService } from '../_services';


export class Header extends Component {
    static displayName = Header.name;

    constructor(props) {
        super(props);
        this.state = {
            showTimeoutModal : false,
        };
        this.checkTokenTimeout = this.checkTokenTimeout.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }

    handleContinue(){
        userService.renewToken(true);
        this.setState({showTimeoutModal: false});
    }
    componentDidMount() {
        window.setInterval(this.checkTokenTimeout, 10000)
    }
    
    checkTokenTimeout(){
        const expiration = userService.getTokenExpiration(); 
        
        if(userService.getCurrentUser()){
            if(expiration <= 120000){
                
                if(expiration <= 0){
                    this.setState({showTimeoutModal: false})
                    history.push("log-out")
                }
                else{
                    if(!this.state.showTimeoutModal){
                        this.setState({showTimeoutModal: true})
                    }
                }
            }
            else{
                if(this.state.showTimeoutModal){
                    this.setState({showTimeoutModal : false});
                }
            }
        }
    }

    render() {
        return (
            <React.Fragment>
            <Modal isOpen={this.state.showTimeoutModal}>
                <ModalHeader>{metadataService.getTitle("SessionExpiration")}</ModalHeader>
                <ModalBody>
                    {metadataService.getMessage("SessionTimeout")}
                </ModalBody>
                <ModalFooter> 
                    <SlButton name="Continue" onClick={this.handleContinue}></SlButton>
                </ModalFooter>
            </Modal>
            <header>
                    <div className="logoContainer"><Link to="/"><img src={logo} alt="Sun Loans Logo" style={{ height: 60, width: 140 }} loading="eager" data-skip-lazy /></Link></div>                    
                    <div className="greyLine"></div>
            </header>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Header.js